import { useHttpsCallable } from "react-firebase-hooks/functions";
import { useEffect, useState } from "react";
import { functions } from "@poseidon/firebase/firebase";

export const useReschedule = (scheduleId) => {
  const [executeCallable, saving, error] = useHttpsCallable(
    functions,
    "reschedule"
  );
  const [complete, setComplete] = useState(false);
  useEffect(() => {
    setComplete(false);
  }, [scheduleId]);
  const reschedule = async ({
    mode,
    addonRate,
    term,
    repayment,
    holidayMonths,
    lumpSum,
    balloon,
  }) => {
    try {
      const result = await executeCallable({
        ...(mode === "term" ? { term } : {}),
        ...(mode === "payment" ? { repayment } : {}),
        // omit to preserve the existing balloon; send a value to override it
        ...(balloon !== "" && balloon != null
          ? { balloon: Number(balloon) }
          : {}),
        mode,
        scheduleId,
        addonRate,
        holidayMonths,
        lumpSum,
      });
      setComplete(true);
      if (!result?.data?.success) {
        throw new Error("Error rescheduling");
      }
      return result.data;
    } catch (err) {
      setComplete(false);
      return {
        success: false,
      };
    }
  };
  return { saving, error, success: !saving && !error && complete, reschedule };
};
